var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgIconCrypton = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#0c8a63",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 11.5,
    stroke: "#885802",
    strokeOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2791 13.1074V13.1055C13.1961 13.1113 12.7678 13.1363 11.8148 13.1363C11.0527 13.1363 10.5183 13.1151 10.3293 13.1055V13.1074C7.39871 12.9781 5.21286 12.4688 5.21286 11.8572C5.21286 11.2476 7.40064 10.7363 10.3293 10.6071V12.6C10.5203 12.6135 11.0701 12.6463 11.8283 12.6463C12.7389 12.6463 13.1942 12.6077 13.2791 12.6V10.609C16.2039 10.7402 18.3839 11.2495 18.3839 11.8592C18.3839 12.4688 16.2019 12.9781 13.2791 13.1093V13.1074ZM13.2791 10.4026V8.61994H17.3595V5.90161H6.2508V8.61994H10.3312V10.4026C7.01479 10.555 4.52219 11.2109 4.52219 11.9981C4.52219 12.7852 7.01672 13.4412 10.3312 13.5955V19.31H13.281V13.5955C16.5916 13.4431 19.0804 12.7871 19.0804 12C19.0804 11.2148 16.5916 10.5569 13.281 10.4045",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconCrypton, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/IconCrypton.964f9bf0.svg";
export { ForwardRef as ReactComponent };